import { LABEL_FONT } from '../../constants';
export var getFontStyles = function (_a) {
    var fontSize = _a.fontSize;
    return ({
        font: LABEL_FONT,
        fontSize: "".concat(fontSize, "px"),
    });
};
//# sourceMappingURL=utils.js.map